import React, { useEffect } from 'react';
import AppRouter from './routes/AppRouter';
import { useAppSelector } from './hooks/useAppSelector';
import { useAppDispatch } from './hooks/useAppDispatch';
import { fetchEnv, selectEnvironment } from './state/environmentSlice';

export default function Main (): React.ReactElement {
  const env = useAppSelector(selectEnvironment);
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    if (env.status !== 'succeeded') {
      dispatch(fetchEnv());
    }
  }, []);
  
  return (
    <main className="main-content is-fullwidth">
      <AppRouter/>
    </main>
  );
}